import { Helmet } from "react-helmet";

export default function OpenGraphSeoConfig() {
  const isProd = import.meta.env.VITE_PROD === "true";

  return isProd ? (
    <Helmet>
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Darvin" />
      <meta
        property="og:title"
        content="Text to Mobile App | AI Flutter App Builder - Darvin"
      />
      <meta
        property="og:description"
        content="AI Flutter app builder that turns text to mobile app in minutes. Build production-ready native Flutter apps for Android and iOS with no code. Try Darvin's flutter AI builder free."
      />
      <meta property="og:url" content="https://darvin.dev/" />
      <meta property="og:locale" content="en_US" />
      <meta
        property="og:image"
        content="https://darvin.dev/assets/og-image.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://darvin.dev/assets/og-image.jpg"
      />
      <meta
        property="og:image:alt"
        content="Darvin AI — build Flutter apps from text"
      />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
    </Helmet>
  ) : null;
}
